/* eslint-disable @typescript-eslint/naming-convention */

export enum ActionType {
    MARKETO_ACTION = 'marketoAction',
    SEW_MAIL_ACTION = 'sewMailAction',
}

interface Etag {
    $oid: string;
}

export interface Property {
    name: string;
    value: string | number;
}

export interface ConditionConnection {
    conditions: { fieldId: string; operator: string; value: string }[];
    affectedFields: { fieldId: string; state: string }[];
    conjunction: boolean;
}

export interface Condition {
    input: string;
    operator: string;
    value: string;
}

export interface ConditionalFields {
    input: string;
    state: string;
}

export type ConditionProperty =
    | { name: 'condition'; value: Condition[] }
    | { name: 'conditional_fields'; value: ConditionalFields[] }
    | { name: 'condition_conjunction'; value: boolean };

export interface WebformsAction {
    property: Property[] | Property;
    'xml:id': string;
    type: ActionType;
    target: string;
}

export interface ElementOption {
    'xml:id': string;
    label: string;
    value: string;
    type: string;
}

export interface Validator {
    name: string;
    'xml:id': string;
    property: Property[] | Property;
}

export type Element = PageBreakElement | FormElement | ConditionElement;

export interface PageBreakElement {
    name: string;
    property: Property[] | Property;
    validator: Validator[] | Validator;
    'xml:id': string;
    label: string;
    type: MwfElementTypes.PAGE_BREAK;
    value: string;
    element: ElementOption[];
}

export interface FormElement {
    name: string;
    property: Property[] | Property;
    validator: Validator[] | Validator;
    'xml:id': string;
    label: string;
    type: MwfElementTypes | string;
    value: string;
    element: ElementOption[];
}

export interface ConditionElement {
    property: ConditionProperty[];
    'xml:id': string;
    type: MwfElementTypes.CONDITION;
}

interface Form {
    elementId: number;
    uid: string;
    formName: string;
    name: string;
    'xml:id': string;
    action?: WebformsAction;
    lang: string;
    version: number;
    projectId: number;
    element: Element[];
    property: Property[] | Property;
}

interface Etag2 {
    $oid: string;
}

export interface FormPage {
    _id: string;
    fs_date: number;
    formular: { form: Form };
    description: string;
    success_message: string;
    title: string;
    fs_uid_type: string;
    fs_scheduler_date: number;
    fs_project_id: number;
    fs_project_name: string;
    fs_revision_id: number;
    fs_id: string;
    fs_language: string;
    fs_reference_name: string;
    fs_object_type: string;
    _etag: Etag2;
    mac?: string;
}

interface Embedded {
    'rh:doc': FormPage[];
}

export interface WebFormResponse {
    _id: string;
    _etag: Etag;
    _returned: number;
    _embedded: Embedded;
}

export enum MwfElementTypes {
    PAGE_BREAK = 'pageBreak', //Kein FormElement (= neuer Stepper)
    INPUT_FIELD = 'inputField',
    RADIO_GROUP = 'radioGroup',
    COMBO_BOX = 'comboBox',
    CHECK_BOX_GROUP = 'checkBoxGroup',
    TEXT_AREA = 'textArea',
    RICH_TEXT_ELEMENT = 'richText',
    FILE_UPLOAD = 'fileUpload',
    PARAGRAPH = 'paragraph', //Text zwischen Formular
    LAYOUT = 'layout', //Unnötig?
    CAPTCHA = 'captcha',
    CONDITION = 'condition',
}

export enum MwfFileType {
    JPG = 'jpg',
    JPEG = 'jpeg',
    PNG = 'png',
    MP4 = 'mp4',
    PDF = 'pdf',
    DOC = 'doc',
    TXT = 'txt',
    XLSX = 'xlsx',
    XLS = 'xls',
    DOCX = 'docx',
    XML = 'xml',
}
